module.exports = __webpack_public_path__ + "static/media/menu-bag.d016649f.svg";